module.exports = "https://cdn.realtymogul.com/static/media/img_PP.1d013c74.jpg";